<template>
    <div>
        <rednax-datatable
            :url="'/vue/suppliers/purchases/items?type=1&is_deprecated=0&mode=gtzero'"
            :columns="table_columns"
            :filter="table_filter"
            @updateFilter="table_filter=$event"
            history
            size="md"
            :per-page="1000"
            sort-by="RowID"
            sort-order="asc"
            ref="purchasesitemstable"
        >
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="table_filter.search" class="form-control"  placeholder="Sök...">
                </div>
            </div>
            <template #cell_ProdPurchaseID="{ row }">
                <router-link v-if="row.ProdPurchaseID > 0" :to="{ name: 'suppliers.purchase', params: { id: row.ProdPurchaseID } }">{{ row.ProdPurchaseID }}</router-link>
                <span v-else>N/A</span>
            </template>
            <template #cell_ProdID="{ row }">
                <router-link :to="{ name: 'products.purchases', params: { id: row.ProdID } }">{{ row.ProdID }}</router-link><MarkedProductIndicator :prod-id="row.ProdID" />
            </template>
            <template #cell_images="{ row }">
                <div v-if="row.images && row.images.length > 0">
                    <img :id="`product-image-${row.ProdID}`" :src="row.images[0].urls['small']" :alt="row.ProdID" style="height: 60px; margin: -8px 0;">
                    <!--                    <div v-if="row.images.length > 1" style="margin-top: 8px; margin-bottom: -8px;">{{ row.images.length }} bilder i popup</div>-->
                    <b-popover :target="`product-image-${row.ProdID}`" triggers="hover">
                        <img :src="row.images[0].urls['medium']" :alt="row.ProdID" style="width: 100%;">
                    </b-popover>
                </div>
            </template>
            <template #cell_product="{ row }">
                <router-link :to="{ name: 'products.purchases', params: { id: row.ProdID } }">{{ row.ProdName }}</router-link>
            </template>
            <template #cell_EffectiveTS="{ row }">
                <div v-if="row.EffectiveTS && row.EffectiveTS.substring(0, 10) !== '0000-00-00'">
                    {{ row.EffectiveTS.substring(0, 10) }}
                </div>
                <div v-if="row.EffectiveTS && row.EffectiveTS.substring(0, 10) !== '0000-00-00'" :class="{ 'text-danger': getDateDiffDays(row.EffectiveTS) <= 0, 'text-success': getDateDiffDays(row.EffectiveTS) > 0 }">
                    {{ getDateDiffDays(row.EffectiveTS) }} dagar
                </div>
            </template>
            <template #cell_Antal="{ row }">
                <button type="button" style="width: 100px;" class="btn btn-success text-center" @click="showModalItemDelivery(0, row.RowID)">{{ row.Antal }}</button>
            </template>
        </rednax-datatable>

        <b-modal id="modal-register-delivery" @hidden="row_id = null; derived_row_id = null;" size="lg" hide-footer title="Inleverans">
            <prod-lager-editor :id="row_id" :derived-id="derived_row_id" include @saved="$refs.purchasesitemstable.reload()"></prod-lager-editor>
        </b-modal>
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import ProdLagerEditor from '@app/pages/suppliers/partials/ProdLagerEditor';

export default {
    name: 'PurchaseItemsList',
    components: {
        RednaxDatatable,
        ProdLagerEditor,
    },
    data: () => ({
        row_id: null,
        derived_row_id: null,
        table_filter: {
            search: '',
            // type: 1,
            // is_deprecated: 0,
        },
        table_columns: [
            {
                header: 'Order ID',
                data: 'ProdPurchaseID',
                sortable: true,
            },
            {
                header: 'Produkt ID',
                data: 'ProdID',
                sortable: true,
            },
            {
                header: 'Bild',
                data: 'images',
                sortable: false,
            },
            {
                header: 'Produkt',
                data: 'ProdName',
                sortable: true,
            },
            {
                header: 'Leverantör',
                data: 'SupplierName',
                sortable: true,
            },
            {
                header: 'Best. Antal',
                data: 'Antal',
                sortable: true,
            },
            {
                header: 'Best.datum',
                data: 'CreatedTS',
                sortable: true,
                render: (row) => row.CreatedTS.substring(0, 10),
            },
            {
                header: 'För.lev.datum',
                data: 'EffectiveTS',
                sortable: true,
            },
            {
                header: 'Ext. Order ID',
                data: 'ExtOrderID',
                sortable: true,
            },
            {
                header: 'Beställare',
                data: 'OrderedByName',
                sortable: true,
            },
        ],
    }),
    methods: {
        getDateDiffDays(dateStr) {
            const today = new Date();
            const date = new Date(dateStr.replace(' ', 'T'));
            return Math.trunc((date.getTime() - today.getTime()) / (24 * 3600 * 1000));
        },
        showModalItemDelivery(rowId, derivedRowID) {
            this.row_id = rowId;
            this.derived_row_id = derivedRowID;

            this.$bvModal.show('modal-register-delivery');
        },
    },
};

</script>
